import { RacemapAPIClient } from '@racemap/utilities/api-client';
import type { StripeInvoiceInfo } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { CurrentEvent } from '../../../store/events/events_reducers';

const apiClient = RacemapAPIClient.fromWindowLocation();

export enum ViewStates {
  ADDRESS = 'ADDRESS',
  OVERVIEW = 'OVERVIEW',
  STRIPE = 'STRIPE',
  DONE = 'DONE',
}

export const checkPaymentStatus = async (eventId: string): Promise<StripeInvoiceInfo> => {
  return await apiClient.checkEventPayment(eventId);
};

export const initPayment = async (event: Immutable<CurrentEvent>): Promise<StripeInvoiceInfo> => {
  return apiClient.initiateEventPayment(event.id);
};
